module.exports = __webpack_public_path__ + "img/img(9).949b1805.png";